import { render, staticRenderFns } from "./MFormMpsOptionsPicker.vue?vue&type=template&id=981b7f08"
import script from "./MFormMpsOptionsPicker.vue?vue&type=script&lang=js"
export * from "./MFormMpsOptionsPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports